import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { filter } from 'rxjs/operators';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  showLogoutModal = false;
  showLDeleteModal = false;
  isMobile: boolean = false;
  userLang: any = 'en';
  // Mobile navigation states
  activeTab: 'personal' | 'services' = 'personal';
  showServicesDropdown = false;
  currentRoute: string = '';

  // Map of routes to page titles
  private pageTitles: { [key: string]: string } = {
    'personal-data': 'personalData',
    'auto-apply-jobs': 'autoApplyJobs',
    'generated-cv': 'generatedCV',
    'evaluated-cvs': 'evaluatedCVs',
    'generated-cover-letters': 'generatedCoverLetters',
    'evaluated-linkdin-profiles': 'evaluatedProfiles',
    'interview-training': 'interviewTraining',
    'change-password': 'changePassword',
  };

  constructor(
    private router: Router,
    private userService: UserService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {
    this.userLang = this.localizationService.getUserLang();
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 991;
    // Track current route
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event) => {
        this.currentRoute = event.url;
        // Close services dropdown when navigating to service pages
        if (!this.isPersonalDataPage()) {
          this.showServicesDropdown = false;
        }
      });

    // Set initial route
    this.currentRoute = this.router.url;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLang = event.lang;
    });
  }

  openLogoutModal() {
    this.showLogoutModal = true;
  }

  closeLogoutModal() {
    this.showLogoutModal = false;
  }
  openDeleteModal() {
    this.showLDeleteModal = true;
  }

  closeDeleteModal() {
    this.showLDeleteModal = false;
  }

  confirmLogout() {
    this.userService.deleteTokenInfo();
    this.userService.deleteUserInfo();
    this.showLogoutModal = false;
    this.router.navigate(['/home']).then(() => {
      window.location.reload();
    });
  }

  // Mobile tab methods
  setActiveTab(tab: 'personal' | 'services') {
    this.activeTab = tab;
    if (tab === 'services') {
      this.showServicesDropdown = true;
    } else {
      this.showServicesDropdown = false;
    }
  }

  toggleServicesDropdown() {
    let toggleValue = !this.showServicesDropdown;
    this.showServicesDropdown = toggleValue;
  }

  // Check if current page is personal data page
  isPersonalDataPage(): boolean {

    return (
      this.currentRoute.includes('personal-data') ||
      this.currentRoute.endsWith('/profile') ||
      this.currentRoute === ''
    );
  }
  isChangePasswordPage(): boolean {
    return (
      this.currentRoute.includes('change-password') ||
      this.currentRoute.endsWith('/profile') ||
      this.currentRoute === ''
    );
  }
  getCurrentPageTitle(): string {
    const segments = this.currentRoute.split('/');
    const lastSegment = segments[segments.length - 1];

    return this.pageTitles[lastSegment] || 'Service';
  }
  goBackToProfile(): void {
    this.router.navigate(['/profile/personal-data']);
    this.activeTab = 'personal';
    this.showServicesDropdown = false;
  }
  goBacktoHome(): void {
    this.router.navigate(['/']);
  }
  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth <= 991;
  }

  deleteUserAccount() {
    this.userService.deleteUserAccount().subscribe({
      next: (res) => {
    
        this.userService.deleteTokenInfo();
        this.userService.deleteUserInfo();
        this.router.navigate(['/']);
      },
      error: (err) => {
        console.error('❌ Error deleting account:', err);
      },
    });
  }
}
